const FormContainer = ({ children }) => {
  return (
    <div className='fadein animation-duration-400' style={{ maxWidth: 400 }}>
      {children}
    </div>
  );
}

export default FormContainer;